import styled from 'styled-components';

import { getPurpurBorder } from '@telialt/common-theme/src/purpurSelectors';

export const StyledSectionImageWrapper = styled.div`
    border-radius: ${getPurpurBorder('radiusLg')};
    overflow: hidden;

    img {
        display: block;
        width: 100%;
        height: auto;
    }
`;
